<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
        <Detail ref="detailRef" />
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item :label="$t('审核意见')" prop="audit">
              <a-radio-group v-model="model.audit">
                <a-radio :value="1">{{ $t('通过') }}</a-radio>
                <a-radio :value="0">{{ $t('驳回') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('备注')" prop="remark">
              <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="24" v-if="model.audit == 1">
            <a-form-model-item label="下一节点操作人" prop="candidateUsers">
              <a-select mode="multiple" placeholder="请选择操作人" v-model="model.candidateUsers">
                <a-select-option :value="item.userName" v-for="item in candidateUsersList">{{item.userRealname}}</a-select-option>
              </a-select> 
            </a-form-model-item>
          </a-col> -->
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction, postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import Vue from 'vue'
import { modes } from 'codemirror'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import JUpload from '@/components/jeecg/JUpload'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import Detail from '../detail'

  export default {
    name: 'ConstructionDetailForm',
    components: {
      JImageUpload,
      JUpload,
      DetailList,
      DetailListItem,
      Detail
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        remarkRequired: true,
        url: {
          isStartProcess: "/jeecg-engineering/engineering/installationDetail/isStartProcess",
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          // userList: "/jeecg-engineering/flowable/definition/userList",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          getApprovalDetail: "/jeecg-engineering/engineering/installationDetail/getApprovalDetail",
          userType: "/jeecg-charge/meter/meterUserType/list",
          editApproverName: "/jeecg-engineering/ticket/tickets/editApproverName"
        },
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        fileList1: [],
        fileList2: [],
        state: '',
        candidateUsersList: [],
        bool: false,
        pastNodes: {},
        clientTypeList: [],
        defaultkey: 1
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      validatorRules () {
        return {
          audit:{ required: true,message: this.$t('请选择审批意见'), trigger: 'change' },
          remark:{ required: this.remarkRequired,message: this.$t('请输入备注'), trigger: 'input' },
          candidateUsers:{ required: true,message: this.$t('请选择下一节点操作人'), trigger: 'change' }
        }
      },
    },
    watch:{
      'model.audit':{
        handler(val){
          if(val == 1){
            this.remarkRequired = false;
          }else{
            this.remarkRequired = true;
          }
        }
      }
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.getUserType();
    },
    methods: {
      getUserType(){
        this.clientTypeList = [];
        getAction(this.url.userType).then(res=>{
          if(res.success){
            res.result.records.map(item=>{
              this.clientTypeList.push({
                utName:item.utName,
                id:item.id
              });
            });
          }
        });
      },
      getUserList(){
        getAction(this.url.userList,{pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record,bool) {
        this.bool = bool;
        this.model = Object.assign({}, record);
        if(bool){//工单进来
          this.model.dataId = record.id;
          this.model.installationId = record.ticketsForeignId;
          this.model.ticketsType = record.ticketsType;
          this.model.ticketsId = record.id;
        }else{
          this.model.dataId = record.ticketsId;
          this.model.installationId = record.id;
          this.model.ticketsType = 1;
          this.model.ticketsId = record.ticketsId;
          this.model.id = record.id;
        }
        this.visible = true;
        this.getUserList();
        this.$nextTick(()=>{
          this.$refs.detailRef.init(record,bool);
        });
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            if(that.model.audit == 1){
              httpurl+=this.url.pass;
            }else{
              httpurl+=this.url.reject;
            }
            let params = {
              // candidateUsers: that.model.candidateUsers,
              dataId: that.model.dataId,
              values: {
                dataId: that.model.dataId
              },
              comment: that.model.remark?that.model.remark:''
            }
            postAction(httpurl,params).then((res)=>{
              if(res.success){
                that.$message.success(this.$t('操作成功'));
                that.$emit('ok');
                // // 更新节点处理人
                // postAction(that.url.editApproverName,{
                //   id: that.bool?'':that.model.id,
                //   ticketsId: that.model.ticketsId,
                //   ticketsType: that.model.ticketsType,
                //   approverName: that.model.candidateUsers&&that.model.candidateUsers.join(','),
                // }).then(val=>{
                //   if(res.success){
                //     // that.$message.success('更新节点处理人成功');
                //     that.$message.success('操作成功');
                //     that.$emit('ok');
                //   }
                // });
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
    }
  }
</script>
<style lang="less" scoped>
  .lab-title{
    font-weight: bold;
    color: #000;
  }
  .ant-collapse{
    background-color: #fff;
  }
  /deep/.detail-list .content {
    line-height: normal;
  }
</style>